module.exports = __webpack_public_path__ + "static/media/followthefood_logo.4b9c8171.svg";